import ajaxError from "./ajaxError";

function getLinks() {
	const section = $(this).attr("data-section");
	const id = $(this).attr("data-id");
	let url = `${links.api.router}/${section}/`;
	if (typeof id !== "undefined") {
		url += id;
	}
	if (typeof window.ofuscatedlinks[url] !== "undefined") {
		return;
	}
	$.ajax({
		method: "GET",
		url,
	}).done((data) => {
		window.ofuscatedlinks[url] = data;
		localStorage.setItem(
			"ofuscatedlinks",
			JSON.stringify(window.ofuscatedlinks),
		);
	});
}

function redirect() {
	const section = $(this).attr("data-section");
	const id = $(this).attr("data-id");
	let url = `${links.api.router}/${section}/`;
	if (typeof id !== "undefined") {
		url += id;
	}
	const data = window.ofuscatedlinks[url];
	window.open(data.url, data.blank ? "_blank" : "_self");
}
function LinkObfuscate() {
	if (localStorage.getItem("ofuscatedlinks") !== null) {
		window.ofuscatedlinks = JSON.parse(localStorage.getItem("ofuscatedlinks"));
	} else {
		window.ofuscatedlinks = {};
	}

	$(".enlace").each(getLinks);

	$(".enlace").click(redirect);
}

export default LinkObfuscate;
